import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const MapPinIcon = React.memo(function MapPinIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 1.5C5.01472 1.5 3 3.51472 3 6C3 8.5 5.5 11.5 7.5 13.5C9.5 11.5 12 8.5 12 6C12 3.51472 9.98528 1.5 7.5 1.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="7.5" cy="6" r="1.5" stroke={color} />
    </svg>
  );
});
